import '../../css/base.css';
import home1_large from '../../img/home1_large.jpg'
import home1_medium from '../../img/home1_medium.jpg'
import home1_small from '../../img/home1_small.jpg'
import scenery4_large from '../../img/scenery4_large.jpg'
import scenery4_medium from '../../img/scenery4_medium.jpg'
import scenery4_small from '../../img/scenery4_small.jpg'
import glenelgView_large from '../../img/glenelgView_large.jpg'
import glenelgView_medium from '../../img/glenelgView_medium.jpg'
import glenelgView_small from '../../img/glenelgView_small.jpg'


const Reviews = () => {

  return (
    <div className="row">
      <div className="col-12 col-md-6 order-1 order-md-1 imagesBackgroundColour">
        <div className="generalText">
          <div className="reviewTextBox">
            <p className="review-text"><em><span className="review-quotes">"</span>Great cottage, great location. Superb swimming, kayaking, fishing, cycling and hill walking are all right on the doorstep.  Doesn't get much better.
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Shaun, Northampton, 2021</strong>
            </p>
            <p className="review-text"><em><span className="review-quotes">"</span>This is escapism at its best: a different world, beauty right at the doorstep, majestic scenery all around. We were slightly worried about the road in (it's marked on OS maps as a track rather than a road, and we were travelling in snow), but it was totally fine, tarmac all the way and gritted too. The house is brilliant, warm and homely, with three good sized bedrooms, a very comfortable living room, a wonderfully well-equipped kitchen with a full family table, and an excellent boot room & pantry space for bags and outdoor kit. The best bit though is the full glass front door that looks directly onto Loch Hourn, and from where we saw otters, stags, sun rises and sunsets. Stunning. The best part was perhaps the night sky: stars like I had never seen them before, framed by the silhouettes of the hills. Shore Cottage's own website has some brilliant suggestions for walks and we spent a week enjoying those, with some afternoon paddle boarding in the loch directly in front of the cottage, and some lovely evenings with the fire and films in the cottage. Absolutely perfect.
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Graham, Scotland, 2022</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-2 order-md-2 imagesBackgroundColour review-image">
        <picture>
          <source srcSet={`${home1_small} 1x,${home1_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${home1_medium} 1x,${home1_large} 2x`}
            src={home1_large} alt="Arnisdale Village" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 order-4 order-md-3 imagesBackgroundColour review-image">
        <picture>
          <source srcSet={`${scenery4_small} 1x,${scenery4_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${scenery4_medium} 1x,${scenery4_large} 2x`}
            src={scenery4_medium} alt="Kayaking at Dry Island" className="image"
          />
        </picture>
      </div>
      <div className="col-12 col-md-6 order-3 order-md-4 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
          <p className="review-text"><em><span className="review-quotes">"</span>We had the most fabulous week in this idyllic cottage- in the wonderful hamlet of Arnisdale . Just feet from the loch itself . The cottage was cosy and warm and well equipped . Enclosed garden for the dogs. Lots of drying room for wet weather gear. Good WiFi . Lovely walks coastal and mountain. Stunning scenery with autumnal colours and snow on the peaks. Near to Gavin Maxwell's Sandaig Islands. Sea kayaking was amazing and we saw seals dolphins and otters, in fact you can see them from the kitchen window!
            Lisa was really helpful when booking.
            A beautiful spot. Highly recommended. We hope to return!
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Helen, Northumberland, 2020</strong>
            </p>
            <p className="review-text"><em><span className="review-quotes">"</span>We had an amazing 3 week stay at Shore Cottage. the immediate location and surrounding area is breath taking.  Great walks, kayaking on the loch, wildlife - lots of otters & eagles.  Perfect.  We only left the peninsula once to go to Castle Donan.  Very clean and comfortable.  Nothing was open when we stayed (Feb/March) but that didn't matter.  Just sitting on the bench outside the cottage was wonderful.  Can't recommend enough, will definitely go back.  For nature lovers and outdoor people it's a dream come true.  Local fish delivered, good (if basic) local(ish) shop & Morrisons delivery made self catering for 3 weeks easy.  Very helpful owners & local caretaker.
Only downside is we had to leave....for now!!
              <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Catherine, Stockport, 2022</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-5 order-md-5 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <p className="review-text"><em><span className="review-quotes">"</span>This cottage is perfect for a quiet get away from modern life holiday, but with excellent internet so you can keep in touch if you need to. Local shop is small and about 10 miles away. The cottage itself is perfect with interesting artwork. It’s location is second to none if you like a quiet life with lots of walks (plus swimming or kayaking etc)
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Carol, Bolton, 2023</strong>
            </p>
            <p className="review-text"><em><span className="review-quotes">"</span>Fantastic holiday, very relaxing. Cottage beautiful, clean, warm and the location is stunning. Everything we wanted and much much more.
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Samantha, Ashford, 2022</strong>
            </p>
            <p className="review-text"><em><span className="review-quotes">"</span>A lovely comfortable cottage with everything you could possibly need in the most beautiful location. Very clean and comfortable - comfy beds, large fluffy towels, high quality crockery etc. 
Very peaceful and relaxing. Would highly recommend. The views are breathtaking and definitely worth the journey.
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Beth, Cheshire, 2021</strong>
            </p>
            <p className="review-text"><em><span className="review-quotes">"</span>Thoroughly enjoyed my stay, even though the weather was iffy. 
Got to see otters, stags,golden and white tailed eagles all within my local walks. Fabulous place if you truly want to get away from it all.
            <span className="review-quotes">"</span></em>
              &nbsp;&nbsp; <strong>Ann, Tamworth, 2021</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-6 order-md-6 imagesBackgroundColour review-image">
        <picture>
          <source srcSet={`${glenelgView_small} 1x,${glenelgView_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${glenelgView_medium} 1x,${glenelgView_large} 2x`}
            src={glenelgView_medium} alt="View from Glenelg Inn" className="image"
          />
        </picture>
      </div>
    </div>
  );
}

export default Reviews;